import React, { useEffect, useState } from 'react';
import { bigwinApi } from '../services/api';

interface AuthImageProps {
  src: string;
  alt: string;
  className?: string;
  onClick?: () => void;
}

/**
 * Lädt ein geschütztes Bild über die API (mit Auth-Header) und zeigt es an.
 * Ein einfaches <img src="/api/..."> funktioniert nicht, weil der Browser dabei
 * keinen Authorization-Header mitschickt und die Bilder bewusst nicht öffentlich
 * abrufbar sind.
 */
const AuthImage: React.FC<AuthImageProps> = ({ src, alt, className, onClick }) => {
  const [objectUrl, setObjectUrl] = useState<string | null>(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let cancelled = false;
    let created: string | null = null;

    setFailed(false);
    setObjectUrl(null);

    bigwinApi.getImage(src)
      .then((response) => {
        if (cancelled) return;
        created = URL.createObjectURL(response.data);
        setObjectUrl(created);
      })
      .catch(() => {
        if (!cancelled) setFailed(true);
      });

    return () => {
      cancelled = true;
      if (created) URL.revokeObjectURL(created);
    };
  }, [src]);

  if (failed) {
    return <div className={`image-fallback ${className || ''}`}>Bild nicht verfügbar</div>;
  }

  if (!objectUrl) {
    return <div className={`image-placeholder ${className || ''}`} />;
  }

  return <img src={objectUrl} alt={alt} className={className} onClick={onClick} />;
};

export default AuthImage;
